import { MessageService } from "primeng/api";
import {
  Component,
  OnInit,
  Input,
  HostListener,
  ElementRef,
} from "@angular/core";
import { HelpersService } from "../../../services/helpers.service";
import { PartnerService } from "../../../services/partner.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AddEditServiceTypeV2Component } from "src/app/components/modals/add-edit-service-type-v2/add-edit-service-type-v2.component";

@Component({
  selector: "app-shared-service-types",
  templateUrl: "./shared-service-types.component.html",
  styleUrls: ["./shared-service-types.component.scss"],
})
export class SharedServiceTypesComponent implements OnInit {
  @Input() partnerID;
  @Input() vatInclusive;
  @Input() messageService: MessageService;
  @Input() currencySymbol;
  @Input() Categories = [];
  @Input() isPortal;
  @Input() isCollections;

  public serviceTypes: any = [];
  public loading = true;
  public category = "";
  public open = "";
  public allServiceTypes: any = [];
  public option = "";
  public editCategory = -1;

  constructor(
    private partnerService: PartnerService,
    public helpersService: HelpersService,
    public modalService: NgbModal,
    private eRef: ElementRef
  ) {}

  ngOnInit() {
    this.getServiceTypes();
  }

  @HostListener("document:click", ["$event"])
  clickout(event) {
    this.option = "";
  }

  setEditCategory(edit) {
    this.editCategory = edit;
  }

  setOption(name) {
    setTimeout(() => {
      this.option = name;
    }, 10);
  }

  setOpen(category) {
    this.open = this.open === category ? "" : category;
  }

  search(search) {
    this.open = "all";
    this.Categories = [];
    let temp = {};
    this.allServiceTypes.forEach((element) => {
      const hoursFloored = Math.floor(element.Hours);
      element.displayTime =
        `${hoursFloored}h` +
        (element.Hours > hoursFloored
          ? ` ${Math.round((element.Hours - hoursFloored) * 60)}min`
          : ``);
      if (search === "" || element.ServiceTypeDescription.includes(search)) {
        if (temp[element.GroupName]) {
          temp[element.GroupName].push(element);
        } else {
          temp[element.GroupName] = [element];
        }
        if (this.Categories.find((x) => x.name === element.GroupName)) {
          this.Categories = this.Categories.map((x) => {
            if (x.name === element.GroupName) {
              x.deletable = false;
            }
            return x;
          });
        } else {
          this.Categories.push({
            name: element.GroupName,
            color: "#" + Math.floor(Math.random() * 16777215).toString(16),
            deletable: false,
          });
        }
      }
    });
    this.serviceTypes = temp;
  }

  addCategory() {
    if (this.category !== "") {
      this.Categories.push({
        name: this.category,
        color: "#" + Math.floor(Math.random() * 16777215).toString(16),
        deletable: true,
      });
      this.category = "";
    }
  }

  deleteCategory(category) {
    if (!this.serviceTypes[category]) {
      this.Categories = this.Categories.filter((x) => x.name !== category);
    } else {
      this.setOpen(category);
    }
  }

  getServiceTypes() {
    this.loading = true;
    this.partnerService
      .getPartnerServiceTypesFull(this.partnerID)
      .subscribe((serviceTypes) => {
        this.allServiceTypes = serviceTypes;
        this.loading = false;
        let temp = {};
        serviceTypes.forEach((element) => {
          if (element.IsActive) {
            const hoursFloored = Math.floor(element.Hours);
            element.displayTime =
              `${hoursFloored}h` +
              (element.Hours > hoursFloored
                ? ` ${Math.round((element.Hours - hoursFloored) * 60)}min`
                : ``);
            if (temp[element.GroupName]) {
              temp[element.GroupName].push(element);
            } else {
              temp[element.GroupName] = [element];
            }
            if (this.Categories.find((x) => x.name === element.GroupName)) {
              this.Categories = this.Categories.map((x) => {
                if (x.name === element.GroupName) {
                  x.deletable = false;
                }
                return x;
              });
            } else if (!this.isCollections) {
              this.Categories.push({
                name: element.GroupName,
                color: "#" + Math.floor(Math.random() * 16777215).toString(16),
                deletable: false,
              });
            }
          }
        });
        this.serviceTypes = temp;
      });
  }

  changeCategoryName(i) {
    const key = Object.keys(this.serviceTypes)[i];
    const categories = {
      Services: this.serviceTypes[key].map((x) => x.ID),
      CategoryName: this.Categories[i].name,
    };
    this.partnerService.setServiceCategory(categories);
    this.editCategory = -1;
  }

  addServiceType(category) {
    let modalRef;
    modalRef = this.modalService.open(AddEditServiceTypeV2Component, {
      size: "lg",
      backdrop: "static",
      windowClass: "dark-mode prelogin-container",
    });
    modalRef.componentInstance.partnerId = this.partnerID;
    modalRef.componentInstance.vatInclusive = this.vatInclusive;
    modalRef.componentInstance.messageService = this.messageService;
    modalRef.componentInstance.GroupName = category;
    modalRef.componentInstance.isCollections = this.isCollections;
    modalRef.result.then(
      (result) => {
        this.Categories = this.Categories.map((x) => {
          if (x.name === category) {
            x.deletable = false;
          }
          return x;
        });
        this.open = category;
        this.getServiceTypes();
      },
      (onrejected) => {
        this.open = category;
        this.getServiceTypes();
      }
    );
  }

  editServiceType(serviceType) {
    this.helpersService.setService(serviceType);
  }
}
